import {Injectable} from '@angular/core';
import { HttpClient } from "@angular/common/http";
import {environment} from "../../../../../environments/environment";
import {Observable} from "rxjs";
import {Carpeta} from "../../interfaces/carpeta";

@Injectable({
  providedIn: 'root'
})
export class BuscarCarpetasService {

  private readonly carpetaUrl: string;

  constructor(private httpClient: HttpClient) {
    this.carpetaUrl = environment.apiUrl + '/shared/carpeta/buscar';
  }

  public __invoke(parametros: any): Observable<Carpeta[]> {
    return this.httpClient.post<Carpeta[]>(this.carpetaUrl, parametros);
  }
}
